import React from "react";
import { Container } from "react-bootstrap";
import { LogoIcon } from "../../assets/icons";
import { LI, UL } from "../../AbstractElements";
import Language from "../Header/Langauge";
import { Profile } from "./Profile";
import { useAuthContext } from "../../_helper/Auth";
import { Link } from "react-router";

export const Header = () => {
  const { token } = useAuthContext();

  return (
    <Container>
      <nav className="d-flex justify-content-between align-items-center">
        <Link to="/">
          <LogoIcon />
        </Link>

        <UL
          attrUL={{
            className: `simple-list  d-flex flex-row align-items-center gap-3 nav-menus`,
          }}
        >
          <LI attrLI={{ className: "onhover-dropdown" }}>
            <Language />
          </LI>

          {!!token && <Profile />}
        </UL>
      </nav>
    </Container>
  );
};
